<script lang="ts" setup>
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const isFixed = ref(false);

const initAni = () => {
  const gTimeLine = gsap.timeline();
  gTimeLine
    .fromTo(
      '.chairman',
      {
        scale: 1
      },
      {
        scale: 1,
        scrollTrigger: {
          trigger: '.chairman',
          start: 'top',
          end: 'bottom',
          scrub: true,
        }
      }
    )
    .fromTo(
      '.chairman__text4',
      {
        scale: 1,
        y: '0%'
      },
      {
        scale: 5,
        y: '180%',
        onComplete: () => {
          gTimeLine.to('.chairman__picBox', {
            opacity: 0,
            duration: 0.5, // 可以根据需要调整渐变的持续时间
            ease: 'power1.inOut' // 可以根据需要选择缓动函数
          });
        },
        scrollTrigger: {
          trigger: '.chairman',
          start: '+=20%',
          end: 'bottom',
          scrub: true,
          pin: true,
          pinSpacing: true
        }
      }
    );

  gTimeLine.fromTo(
    '.chairman__picBox',
    {
      opacity: 1
    },
    {
      opacity: 0,
      scrollTrigger: {
        trigger: '.chairman',
        start: '+=20%', // 延迟开始透明度渐变
        end: 'bottom',
        scrub: true
      }
    }
  );
};

const refChairman = ref();
const hasChairmanPicFixed = ref(false);

const handleScroll = e => {
  let picData = refChairman.value.getBoundingClientRect();
  if (picData.top <= 0) {
    hasChairmanPicFixed.value = true;
  } else {
    hasChairmanPicFixed.value = false;
  }
};

defineExpose({
  initAni
});
// onMounted(() => {
//   // initAni()
//   nextTick(() => {
//     useImagesLoaded('.chairman img').then(initAni)
//   });
// });

onMounted(() => {
  document.addEventListener('scroll', handleScroll);
});

onUnmounted(() => {
  document.removeEventListener('scroll', handleScroll);
});
</script>

<template>
  <div class="relative">
    <div class="chairman__picBox" :class="{ isFixed: hasChairmanPicFixed }">
      <figure class="chairman__pic">
        <Nimg src="./images/story/chairman.jpg"></Nimg>
      </figure>
    </div>
    <section class="chairman" ref="refChairman">
      <div class="chairman__text">
        <div class="chairman__text1">
          chairman’s
          <br />
          message
        </div>
        <div class="chairman__text2">陳政鴻 董事長的話</div>
        <div class="chairman__text3">
          支持我熱情前進的動力，​來自於好奇心​
          <br />
          從「心」出發​
          <br />
          理解消費者需求，重視合作夥伴
          <br />
          再帶著大家一起
        </div>
        <div class="chairman__text4">讓生活大於想像</div>
      </div>
    </section>
  </div>
</template>

<style lang="scss" scoped>
.chairman {
  position: relative;
  // overflow: hidden;
  text-align: center;
  color: $color-white-1;

  // color: #000;
  // margin-left: toRem(-24);
  // margin-right: toRem(-24);
  &.isFixedssss {
    .chairman {
      &__text {
        padding-top: 100vh;
      }
    }
  }

  &__picBox {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 0;

    &.isFixed {
      position: fixed;
      left: 0;
      top: 0;
    }
  }

  &__pic {
    transform: translateX(toRem(-24));
    width: calc(100% + toRem(48));
    z-index: -1;
    height: 100%;

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__text {
    position: relative;
    z-index: 2;
    padding-top: 20%;
    // padding-top: 100vh;
    // position: absolute;
    // left: 50%;
    // top: 0;
    // z-index: 1;
    // transform: translateX(-50%);
    // padding-top: toRem(200);
  }

  &__text1 {
    margin-bottom: toRem(12);
    font-size: toRem(60);
    font-family: $font-TextaAlt;
    font-weight: 500;
    line-height: 0.8;
  }

  &__text2 {
    margin-bottom: toRem(56);
    font-size: toRem(22);
  }

  &__text3 {
    margin-bottom: toRem(300);
    font-size: toRem(16);
    font-weight: 400;
    line-height: 1.45;

    @include max-height-media(790) {
      margin-bottom: toRem(200);
    }
  }

  &__text4 {
    position: relative;
    z-index: 2;
    padding-bottom: toRem(300);
    // margin-bottom: toRem(350);
    font-size: toRem(20);
    font-weight: 500;
    line-height: 1.3;
  }

  &__text5 {
    font-size: toRem(80);
    font-weight: 500;
    line-height: 1.3;
  }
}
</style>
